
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("pdp", ["bottomline"]),
    rating() {
      return Number(this.bottomline?.average_score ?? 0);
    },
    ratingCount() {
      return this.bottomline?.total_review ?? 0;
    },
  },
};
